import { Controller } from "@hotwired/stimulus"
import { createRoot } from "react-dom/client"
import AwardForm from "../components/AwardForm"

// Mount point for the new/edit award screen: hands the server-rendered config
// (action, csrf, kinds, places, current values, photo) to the React form.
export default class extends Controller {
  static values = { config: Object }

  connect() {
    this.root = createRoot(this.element)
    this.root.render(<AwardForm config={this.configValue} />)
  }

  disconnect() {
    this.root?.unmount()
  }
}
